module.exports = __webpack_public_path__ + "static/media/d-link_logo.05da3ca6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/d-link_logo.svg
// module id = 404
// module chunks = 0